export const MuiInputAdornment = {
  styleOverrides: {
    positionEnd: {
      marginLeft: 0,
    },
  },
};
